export default __webpack_public_path__ + "static/media/motorbike.5f505b7c.png";